<div class="icon-box">
  <mat-icon [svgIcon]="'academic'" class="square-icon person-icon"></mat-icon>
</div>
<div class="position">{{ data.title }}</div>
<div class="name">{{ data.fullName }}</div>
<div class="phones">
  <span *ngFor="let contact of data.contacts; let l = last">{{ contact }}<ng-container *ngIf="!l">, </ng-container></span>
</div>
